import { useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { documentFlush } from 'shared/domains/documents';
import { useAccount } from 'shared/domains/users';
import { FlushInfoModal } from './FlushInfoModal';
import { isUserMatch } from './utils';
export function DocumentFlushModal() {
    const flush = useReactiveVar(documentFlush);
    const history = useHistory();
    const { data: accountData } = useAccount();
    const { userId: currentUserId } = accountData;
    const isCurrentUserInitiator = flush.state === 'done' && isUserMatch(currentUserId, flush.initiatorUserId);
    useEffect(() => {
        if (flush.state === 'done' && isCurrentUserInitiator) {
            documentFlush({ state: 'not-initialized' });
        }
    }, [flush, history, isCurrentUserInitiator]);
    if (flush.state !== 'done' || isCurrentUserInitiator) {
        return null;
    }
    const { reason, initiatorUserId } = flush;
    return <FlushInfoModal reason={reason} initiatorUserId={initiatorUserId}/>;
}
